import React from 'react'
import * as yup from 'yup'

import { whistleblowerRetaliationEmployer } from '../../../../choices'
import { otherChoicePage } from '../../../../pages'
import {
  addressLabel,
  address2Label,
  optionalLabel
} from '../../../../strings/labels'
import {
  workPlaceLengthMessage,
  addressLengthMessage,
  cityLengthMessage,
  zipLengthMessage,
  zipMessage
} from '../../../../strings/messages'
import { zipRegex } from '../../../../strings/regex'
import { Divider } from '../../../../components/divider'
import css from '../../../ComplaintForm/ComplaintForm.module.css'

export const employmentPage = () => {
  const WorkAddressHeading = () => (
    <span className="ds-u-margin-bottom--0 ds-u-font-size--h2 ds-u-font-weight--bold">
      Optional: Your work address
    </span>
  )

  const WorkLocationText = () => (
    <div>
      The physical location of where you worked at the time of the retaliatory
      action(s)
    </div>
  )

  const workAddressFields = [
    {
      type: 'content',
      content: Divider,
      name: 'divider1'
    },
    {
      type: 'content',
      content: WorkAddressHeading,
      name: 'work_address_heading'
    },
    {
      type: 'content',
      content: WorkLocationText,
      name: 'location_text'
    },
    {
      type: 'text',
      label: 'Place name (company, organization, department, etc.)',
      name: 'work_place'
    },
    {
      type: 'address',
      name: 'work_address',
      label: '',
      hint: '',
      line1Label: addressLabel,
      line2Label: address2Label,
      line1RequirementLabel: optionalLabel,
      line2RequirementLabel: optionalLabel,
      cityRequirementLabel: optionalLabel,
      stateRequirementLabel: optionalLabel,
      zipRequirementLabel: optionalLabel,
      countryValue: 'US'
    }
  ]

  const workAddressValidation = {
    work_place: yup.string().max(150, workPlaceLengthMessage),
    work_address: yup.object().shape({
      line1Value: yup.string().max(50, addressLengthMessage),
      line2Value: yup.string().max(50, addressLengthMessage),
      cityValue: yup.string().max(30, cityLengthMessage),
      zipValue: yup
        .string()
        .max(10, zipLengthMessage)
        .test('work_zipcode_required', zipMessage, function(value) {
          const { countryValue } = this.parent
          return countryValue === 'US'
            ? value === '' || zipRegex.test(value)
            : true
        })
    })
  }

  const props = {
    pageId: 'employment_page',
    fieldName: 'complainant_employer',
    fieldNameOther: 'employer_other',
    label: 'Where did you work at the time of the retaliatory action(s)?',
    labelOther: 'Please enter your other workplace',
    className: css.choices,
    labelClassName: css.largeLabel,
    choices: whistleblowerRetaliationEmployer(),
    additionalFields: workAddressFields,
    additionalValidation: workAddressValidation
  }

  const page = otherChoicePage({ ...props })

  return {
    ...page,
    action: {
      type: 'goto',
      pageId: values => {
        return values.complainant_employer === 'Other' ||
          values.complainant_employer === 'Medical Care Provider'
          ? 'employment_warning_page'
          : 'action_begin_date_page'
      }
    }
  }
}
